import Portal from './Portal'
import { motion, AnimatePresence } from 'framer-motion'
import style from 'css/Alert.module.css'

const Modal = ({ show, children, title, setShow, confirm = false, onCancel, onClickOk }) => {

	return (
		<Portal to="modal">
			<AnimatePresence>
				{show &&
					<AlertWin title={title} setShow={setShow} confirm={confirm} onCancel={onCancel} onClickOk={onClickOk}>
						{children}
					</AlertWin>
				}
			</AnimatePresence>
		</Portal>
	)
}

const AlertWin = ({ setShow, title, children, confirm, onCancel, onClickOk }) => {

	//#region Methods
	const onOk = (e, cb) => {	
		if (onClickOk) {
			onClickOk()
		} else {
			setShow(false)
		}
	}

	const cancelAlert = (e) => {
		if (onCancel) {
			onCancel()
		} else {
			setShow(false)
		}
	}
	//#endregion

	//#region Variants
	const dimVariants = {
		initial: {
			backdropFilter: "blur(0px)",
			WebkitBackdropFilter: "blur(0px)",
			backgroundColor: "rgba(0, 0, 0, 0)",
		},
		animate: {
			backdropFilter: "blur(5px)",
			WebkitBackdropFilter: "blur(5px)",
			backgroundColor: "rgba(0, 0, 0, 0.7)",
		},
		exit: {
			backdropFilter: "blur(0px)",
			WebkitBackdropFilter: "blur(0px)",
			backgroundColor: "rgba(0, 0, 0, 0)",
		}
	}

	const winVariants = {
		initial: {
			scale: 0,
			opacity: 0
		},
		animate: {
			scale: 1,
			opacity: 1
		},
		exit: {
			scale: 0,
			opacity: 0
		},
	}
	//#endregion

	return (
		<motion.div className={`${style.Alert} ${style.show}`} variants={dimVariants} initial="initial" animate="animate" exit="exit">
			<motion.div className={style.modalWindow} variants={winVariants}>
				{title &&
					<div className={style.modalTitle}>
						{title}
						<div className="icon_close" onClick={cancelAlert} />
					</div>
				}
				<div className={style.modalContent}>
					{children &&
						// <div dangerouslySetInnerHTML={{ __html: children }} />
						<div>{children}</div>
					}
				</div>
				<div className={style.button_box}>
					{confirm && <button className={style.button} onClick={cancelAlert}>취소</button>}
					<button className={`${style.button} ${style.button_ok}`} onClick={onOk}>확인</button>
				</div>
			</motion.div>
		</motion.div>
	)
}

export default Modal
